<mat-card class="item_actu_item">
  <div class="img_card">
    <a [href]="item.links[0].uri">
      <img *ngIf="item.enclosure.uri" rel="preload" as="image" [src]="item?.enclosure.uri" [alt]="item.title">
    </a>
  </div>
  <mat-card-content class="item_content">
    <div class="hashtag" *ngIf="item.categories[0]">
      <span *ngFor="let i of item.categories">
        #
        <span class="keyword" (click)="keyword($event)">{{i.name}}
        </span>
      </span>
    </div>
    <a [href]="item.links[0].uri">
      <h1>{{item.title}}</h1>
      <p class="infos" *ngIf="item.contributors[0]">{{item.contributors[0].name}} <span
          *ngIf="item.contributors[0].name">-</span>
        <span *ngIf="item.published">{{item.published}}</span>
      </p>
      <p class="description" *ngIf="item.description.length < 500" [innerHTML]="item.description"> </p>
      <div class="more">Plus</div>
    </a>
  </mat-card-content>
</mat-card>